module.exports = __webpack_public_path__ + "img/urgent-diet-table.8d8762fd.png";